import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import axios from "axios"; 
import { Provider } from 'react-redux';
import store from './redux/store';

axios.interceptors.request.use(
  (config) => {
    const requireheader = config?.requireheader;
    if (requireheader === false) {
      config.headers["Content-Type"] = "application/json";
      return config;}
    else {
    config.headers["Client-App-Key"] = process.env.REACT_APP_API_KEY;
    config.headers["Client-App-Type"] = process.env.REACT_APP_API_TYPE;
 
    config.headers["Content-Type"] = "application/json";
 
    return config;
    }
  },
  (error) => Promise.reject(error)
);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store ={store}>
    <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
